/**
 * en-GB messages added by Phase 1 task S4 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s4EnGB = {
    'nav.notices': 'Notices',
    'nav.notices.desc': 'Notices and agreements people accept at sign-in',
    'error.notice_in_use': 'People have already accepted this notice, so it cannot be deleted. Archive it instead.',
    'error.notice_required': 'A notice that must be accepted or signed has not been.',
    'error.notice_hash_mismatch': 'The notice shown is not the current text of that version.',
    'error.notice_site_restricted': 'Notices are shared across every site, so only users with access to all sites can change them.',
    'error.notice_not_assignable': 'Only active notices can be shown at a site.',
    'error.notice_duplicate': 'A notice can only appear once in the list.',
    'warning.notice_version_unknown': 'An accepted notice version was not found and was ignored.',
    'warning.notice_hash_mismatch': 'The text shown on the device did not match the stored version.',
    'warning.notice_required': 'A required notice was not accepted.',
    'warning.notices_input_invalid': 'The notice step data was not understood and was ignored.',
};
//# sourceMappingURL=s4.js.map